module.exports = __webpack_public_path__ + "img/service.efb9329d.svg";